// extracted by mini-css-extract-plugin
export default {"promoCode":"_ea54d8fd"};